import React, {useState} from "react";
import {usePatronTheme, Box, Button, FormGroup, TextInput} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {IconEyeSlash, IconEye} from "@unibuddy/icons";

import {PASSWORD_MINIMUM_LENGTH} from "./RegisterPage1Form";
import {isFunction} from "../../../../util/isFunction";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_PASSWORD} from "../../../../translations/signup";
import {INTL_HIDE_PASSWORD, INTL_SHOW_PASSWORD} from "../../../../translations/login";
import {INTL_PASSWORD_MIN_CHAR_SHORT} from "../../../../translations/validations";

type PasswordInputProps = {
    name?: string;
    required?: boolean;
};

export const PasswordInput = ({name = "password", required = false}: PasswordInputProps) => {
    const theme = usePatronTheme();
    const [showPassword, setShowPassword] = useState(false);
    const {t} = useTranslation([
        IntlNamespaces.SIGNUP,
        IntlNamespaces.VALIDATIONS,
        IntlNamespaces.LOGIN,
    ]);

    return (
        <Box position="relative">
            <FormGroup
                id="password"
                label={t(INTL_PASSWORD.key, INTL_PASSWORD.defaultValue)}
                helpBottom={t(
                    `${IntlNamespaces.VALIDATIONS}:${INTL_PASSWORD_MIN_CHAR_SHORT.key}`,
                    isFunction(INTL_PASSWORD_MIN_CHAR_SHORT.defaultValue)
                        ? INTL_PASSWORD_MIN_CHAR_SHORT.defaultValue(PASSWORD_MINIMUM_LENGTH)
                        : INTL_PASSWORD_MIN_CHAR_SHORT.defaultValue,
                    {
                        minChar: PASSWORD_MINIMUM_LENGTH,
                    },
                )}
            >
                <TextInput
                    name={name}
                    required={required}
                    autoComplete="new-password"
                    type={showPassword ? "text" : "password"}
                    style={{paddingRight: 60}}
                    data-test-id="password"
                />
            </FormGroup>

            <Box position="absolute" right={4} top={24} zIndex={1}>
                <Button
                    type="button"
                    clear
                    iconOnly
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={
                        showPassword
                            ? t(
                                  `${IntlNamespaces.LOGIN}:${INTL_HIDE_PASSWORD.key}`,
                                  INTL_HIDE_PASSWORD.defaultValue,
                              )
                            : t(
                                  `${IntlNamespaces.LOGIN}:${INTL_SHOW_PASSWORD.key}`,
                                  INTL_SHOW_PASSWORD.defaultValue,
                              )
                    }
                    aria-controls="password"
                    aria-live="polite"
                >
                    {showPassword ? (
                        <IconEyeSlash color={theme?.colors?.textColor} />
                    ) : (
                        <IconEye color={theme?.colors?.textColor} />
                    )}
                </Button>
            </Box>
        </Box>
    );
};
